export default "__VITE_ASSET__BKN0yRjp__"